<template>
  <div class="leftWrap">
    <div class="switchFix" v-if="isSwitch"></div>
    <div class="menuWrap">
      <div
        class="menuItem"
        :class="{ on: menuLeftIndex === i }"
        v-for="(item, i) in menuLeft"
        @click="menuLeftChange(i)"
        :key="i"
      >
        <div class="imgBgBox" :class="`icon_${i}`"></div>
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div class="sidebarWrap">
      <div class="sidebarBox" :class="{ w640: isSwitch }">
        <div
          class="switch"
          @click="
            isSwitch = !isSwitch
            $emit('upSwitch', isSwitch)
          "
        >
          <a-icon class="icon" v-if="isSwitch" type="left" />
          <a-icon class="icon" v-if="!isSwitch" type="right" />
        </div>
        <div class="sidebarHide" v-show="menuLeftIndex === 0">
          <div class="hideBox">
            <div class="sidebarHead" v-show="!isShowDetail">
              <div class="stWrap clearFix">
                <div
                  class="stItem"
                  :class="{ on: searchCondition.is_customer_category === 0 }"
                  @click="isCategoryChange(0)"
                >
                  {{ $t('design.allProducts') }}
                </div>
                <div
                  class="stItem"
                  :class="{ on: searchCondition.is_customer_category === 1 }"
                  @click="isCategoryChange(1)"
                >
                  {{ $t('design.myProducts') }}
                </div>
              </div>
              <div class="clearFix" id="hSpBox">
                <span class="stBtn fl" :class="{ on: treeVisible }">
                  <a-popover
                    :visible="treeVisible"
                    placement="bottomLeft"
                    :trigger="['click']"
                    overlayClassName="treeOverlayWrap"
                    @visibleChange="handleClickChange"
                    :getPopupContainer="() => document.getElementById('hSpBox')"
                  >
                    <template slot="content">
                      <div>
                        <RenderTree
                          v-if="searchCondition.is_customer_category === 0"
                          :treeData="treeData"
                          ref="renderTree"
                          @change="
                            treeVisible = false
                            categorySelect = []
                          "
                          :seleced.sync="searchCondition.category_id"
                          :type="'menu'"
                        />
                        <RenderTree
                          @change="
                            treeVisible = false
                            categorySelect = []
                          "
                          v-if="searchCondition.is_customer_category === 1"
                          :treeData="userCategoryTreeData"
                          ref="renderTree"
                          :seleced.sync="searchCondition.category_id"
                          :type="'menu'"
                        />
                      </div>
                    </template>
                    <div class="hSpBox" @click="isCategoryId = !isCategoryId">
                      <a-icon class="menuBtn" type="menu" @click="isShowLayers = false" />
                    </div>
                  </a-popover>
                </span>
                <span class="inputCss fr" :class="{ maxWidth: isSwitch }">
                  <a-input
                    placeholder="Please enter the product name or code"
                    allowClear
                    style="width: 100%"
                    @search="search"
                    @pressEnter="search"
                    v-model="searchCondition.keyword"
                  >
                    <img src="@/assets/icons/search3.png" slot="suffix" class="hover" @click="search" />
                  </a-input>
                </span>
              </div>
            </div>
            <div class="sidebarMain" v-show="!isShowDetail">
              <div class="sidebarMainAuto clearFix">
                <a-empty style="margin-top: 30px" v-if="imgList.length === 0" />
                <div class="imgListWrap">
                  <div class="ctSpBox" v-if="categorySelect.length">
                    <span v-for="(ct, ctI) in categorySelect" :key="ctI" @click="spliceCategory()">
                      &lt;{{ ct.name }}</span
                    >
                  </div>
                  <template v-if="isGroup">
                    <template v-for="(it, itI) in imgList">
                      <div class="imgListItem" :key="itI" v-if="it.basic_products.length">
                        <div class="imgListTop">
                          <span>{{ it.name }}</span>
                          <span class="pointer" @click="addCategory(it)">{{ $t('generic.more') }}></span>
                        </div>
                        <div class="clearFix">
                          <div
                            :class="{ imgItem: true, imgItemActive: value.id === imgId, fuzzy: value.dtc_enable === 2 }"
                            v-for="(value, index) in it.basic_products"
                            v-show="index < 4 || isSwitch"
                            :key="index"
                            @click="dtcEnableFn(value)"
                            @mouseenter="showImgDetailMethod(value)"
                            @mouseleave="setShowImgDetail(false)"
                            :style="{ backgroundImage: `url(${value.view_image_src || ''})` }"
                          >
                            <span v-if="value.is_timeliness === 1 || value.is_timeliness_plus === 1" class="fast"
                              >FAST</span
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="clearFix">
                      <div
                        :class="{ imgItem: true, imgItemActive: value.id === imgId, fuzzy: value.dtc_enable === 2 }"
                        v-for="(value, index) in imgList"
                        :key="index"
                        @click="dtcEnableFn(value)"
                        @mouseenter="showImgDetailMethod(value)"
                        @mouseleave="setShowImgDetail(false)"
                        :style="{ backgroundImage: `url(${value.view_image_src || ''})` }"
                      >
                        <span v-if="value.is_timeliness === 1 || value.is_timeliness_plus === 1" class="fast"
                          >FAST</span
                        >
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="sidebarMain" v-show="isShowDetail">
              <div class="detailWrap">
                <h5 class="nameTit" @click="isShowDetail = false" v-if="configData.showReturn">
                  <a-icon type="left" />Return to view all products{{ printImgInfo.dtc_enable }}
                </h5>
                <div class="cpInfoBox clearFix">
                  <div class="imgBox" @click="showFn">
                    <ImgLoading
                      :src="printImgInfo.product_show_master_image"
                      :class="{ fuzzy: printImgInfo.dtc_enable === 2 }"
                    />
                  </div>
                  <div class="cpInfo">
                    <h6 :title="printImgInfo.en_name">{{ printImgInfo.en_name }}</h6>
                    <p class="code">(Product Code: {{ printImgInfo.code }})</p>
                    <p class="money">
                      <span class="price">
                        {{
                          (priceData.is_promotion === 1 ? priceData.promotion_price : priceData.purchase_price)
                            | rateAmountLocal
                        }}
                        <span class="old_pricce" v-if="priceData.is_promotion === 1">{{
                          priceData.purchase_price | rateAmountLocal
                        }}</span>
                      </span>
                    </p>
                    <p class="money">
                      <span v-if="priceData.is_promotion === 1" class="promotion_percent">
                        -{{
                          (
                            ((Number(priceData.purchase_price) - Number(priceData.promotion_price)) /
                              priceData.purchase_price) *
                            100
                          ).toFixed(0)
                        }}%
                      </span>
                    </p>
                    <p class="money">
                      <span class="small yellow" v-if="+priceData.fba_purchase_price > 0"
                        >FBA预购价:${{ priceData.fba_purchase_price }}</span
                      >
                    </p>
                    <p
                      class="viewBtn"
                      @click="
                        productVisible = true
                        boxIndex = 0
                        productIndex = 0
                      "
                    >
                      View details>
                    </p>
                  </div>
                </div>
                <h5 class="listTitle">Product size</h5>
                <div class="listBox clearFix">
                  <span
                    class="sizeSp"
                    :class="{ on: +initialSize === +it.id }"
                    v-for="(it, itI) in printImgInfo.sizes"
                    :key="itI"
                    @click="changeSize(it.id)"
                  >
                    {{ it.en_name }}
                  </span>
                </div>
                <h5 class="listTitle">Product color</h5>
                <div class="listBox clearFix">
                  <span
                    class="colorSp"
                    :class="{ on: +initialColor === +it.id }"
                    :title="it.en_name"
                    :style="{ background: it.tone }"
                    v-for="(it, itI) in printImgInfo.colors"
                    :key="itI"
                    @click="changeColor(it.id)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="paginationBox">
            <a-pagination
              v-show="!isShowDetail && !isGroup"
              simple
              :default-current="1"
              :total="searchCondition.total"
              :current="searchCondition.page"
              :page-size="15"
              @change="
                current => {
                  getImgListMethod({ ...searchCondition, page: current })
                }
              "
            />
          </div>
        </div>
        <div class="sidebarHide" v-show="menuLeftIndex === 1">
          <div class="hideBox">
            <div class="sidebarHead">
              <div class="stWrap clearFix">
                <div class="stItem" :class="{ on: searchCondition2.is_system === 0 }" @click="isSystemChange(0)">
                  {{ $t('generic.myGallery') }}
                </div>
                <div class="stItem" :class="{ on: searchCondition2.is_system === 1 }" @click="isSystemChange(1)">
                  {{ $t('design.shareGallery') }}
                </div>
              </div>
              <div>
                <a-select
                  style="width: 100%; margin-bottom: 10px; color: #333"
                  :value="searchCondition2.user_id"
                  @change="userMapChange"
                >
                  <!-- <a-select-option value="">账号选择</a-select-option> -->
                  <a-select-option v-for="(value, index) in userMap" :key="index" :value="value.id">
                    {{ value.name }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="upImgWrap" @click="getVolumeMethod">
                <img src="@/assets/design/new_up.png" alt="" />
                {{ $t('design.uploadPicture') }}
              </div>
              <div class="clearFix" id="customerBox">
                <span class="inputCss fl" :class="{ maxWidth: isSwitch }">
                  <a-input
                    :placeholder="$t('generic.search')"
                    allowClear
                    style="width: 100%"
                    @search="search2"
                    @pressEnter="search2"
                    v-model="searchCondition2.name"
                  >
                    <img src="@/assets/icons/search3.png" slot="suffix" class="hover" @click="search2" />
                  </a-input>
                </span>
                <span class="stBtn customerBtnBox fr" :class="{ on: customerTreeVisible }">
                  <a-popover
                    placement="bottomLeft"
                    :visible="customerTreeVisible"
                    :trigger="['click']"
                    overlayClassName="treeOverlayWrap"
                    @visibleChange="customerTreeVisibleChange"
                    :getPopupContainer="() => document.getElementById('customerBox')"
                  >
                    <template slot="content">
                      <div>
                        <RenderTree
                          v-if="searchCondition2.is_system === 0"
                          :treeData="treeData2"
                          ref="renderTree"
                          @change="customerTreeVisible = false"
                          :seleced.sync="customerData.customer_category_id"
                          :type="'menu'"
                        />
                        <RenderTree
                          @change="customerTreeVisible = false"
                          v-if="searchCondition2.is_system === 1"
                          :treeData="menuList"
                          ref="renderTree"
                          :seleced.sync="customerData.customer_category_id"
                          :type="'menu'"
                        />
                      </div>
                    </template>
                    <div class="hSpBox" @click="isCategoryId = !isCategoryId">
                      <!-- <a-icon class="menuBtn" type="menu" @click="isShowLayers = false" /> -->
                    </div>
                  </a-popover>
                </span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-top: 10px">
                <span class="tabList bg1">
                  <span
                    >{{
                      isDesigned.filter(it => {
                        return searchCondition2.is_designed === it.id
                      })[0].name || ''
                    }}
                  </span>
                  <div class="tabPop">
                    <div class="tabPopBox">
                      <div
                        class="popList"
                        v-for="(it, i) in isDesigned"
                        :key="i"
                        @click="
                          searchCondition2.is_designed = it.id
                          search2()
                        "
                      >
                        <span :title="it.name">
                          {{ it.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </span>
                <span class="tabList bg2">
                  <span
                    >{{
                      shapeData.filter(it => {
                        return searchCondition2.shape === it.id
                      })[0].name || ''
                    }}
                  </span>
                  <div class="tabPop">
                    <div class="tabPopBox">
                      <div
                        class="popList"
                        v-for="(it, i) in shapeData"
                        :key="i"
                        @click="
                          searchCondition2.shape = it.id
                          search2()
                        "
                      >
                        <span :title="it.name">
                          {{ it.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </span>
                <span class="tabList bg3">
                  <span
                    >{{
                      searchCondition2.tags === ''
                        ? this.$t('design.pictureLabel')
                        : allTags.filter(it => {
                            return searchCondition2.tags === it.tags
                          })[0].tags || ''
                    }}
                  </span>
                  <div class="tabPop">
                    <div class="tabPopBox">
                      <div
                        class="popList"
                        @click="
                          searchCondition2.tags = ''
                          search2()
                        "
                      >
                        <span title="pictureLabel">
                          {{ $t('design.pictureLabel') }}
                        </span>
                      </div>
                      <div
                        class="popList"
                        v-for="(it, i) in allTags"
                        :key="i"
                        @click="
                          searchCondition2.tags = it.tags
                          search2()
                        "
                      >
                        <span :title="it.tags">
                          {{ it.tags }}
                        </span>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div class="sidebarMain">
              <div class="sidebarMainAuto clearFix">
                <a-empty style="margin-top: 30px" v-if="designImgList.data ? designImgList.data.length === 0 : 0" />
                <div
                  class="imgItem noBor"
                  v-for="(value, index) in designImgList.data"
                  :key="index"
                  @click="addImgToFabric(value)"
                  @mouseenter="showImgDetailMethod(value)"
                  @mouseleave="setShowImgDetail(false)"
                  @dragstart="startImgMove(value)"
                  @drag="imgMoving"
                  @dragend="endImgMove(value)"
                >
                  <span class="tort" v-if="value.is_tort">
                    <span>{{ $t('design.tort') }}</span>
                    <img src="@/assets/icons/buyer.png" alt="" />
                  </span>
                  <ImgLoading :src="value.thumbnail_src" width="100%" height="100%" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="paginationBox">
            <a-pagination
              simple
              :default-current="1"
              :total="searchCondition2.total"
              :current="searchCondition2.page"
              :page-size="16"
              @change="
                current => {
                  getDesignImgListMethod({ ...searchCondition2, page: current })
                }
              "
            />
          </div>
        </div>
        <div class="sidebarHide" v-show="menuLeftIndex === 2">
          <div class="hideBox">
            <div class="sidebarHead">
              <div class="addTextBtn" @click="addFontInToFabric">
                {{ $t('design.addText') }}
              </div>
              <template v-if="canvasType === 'text'">
                <div class="fontInpue">
                  <a-textarea
                    allowClear
                    :placeholder="$t('design.enterText')"
                    :value="textValue"
                    @input="textValueChange"
                  />
                </div>
                <div class="fontSelect clearFix">
                  <div class="fontWrap" :class="{ maxWidth: isSwitch }">
                    <a-select
                      style="width: 100%"
                      @change="changFont"
                      :value="font"
                      :getPopupContainer="
                        triggerNode => {
                          return triggerNode.parentNode || document.body
                        }
                      "
                    >
                      <a-select-option :value="value" v-for="(value, index) in fontList" :key="index">
                        <span :style="{ fontFamily: value }">{{ value }}</span>
                      </a-select-option>
                    </a-select>
                  </div>
                  <div class="fontSizeWrap">
                    <a-dropdown
                      :getPopupContainer="
                        triggerNode => {
                          return triggerNode.parentNode || document.body
                        }
                      "
                    >
                      <div slot="overlay">
                        <div class="overlayWrap w70">
                          <div
                            class="fontSizeItem"
                            v-for="(item, i) in fontSizeData"
                            :key="i"
                            @click="changeFontSizeSelect(item)"
                          >
                            {{ item }}
                          </div>
                        </div>
                      </div>
                      <span class="sizeSp">{{ fontSize }}</span>
                    </a-dropdown>
                    <div class="caretBox">
                      <div>
                        <a-icon class="caretBtn" type="caret-up" @click="changeFontSize('plus')" />
                      </div>
                      <div>
                        <a-icon class="caretBtn" type="caret-down" @click="changeFontSize('minus')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="fontColorWrap"
                  v-if="
                    !print_areas.filter(item => {
                      return item.view_id === activeDesign && item.design_style
                    }).length
                  "
                >
                  <div class="fontColorTit">
                    <span>
                      {{ $t('design.fontColor') }}
                    </span>
                    <span style="font-size: 0">
                      <span class="showColorBtn" @click="showColor">
                        <img src="@/assets/design/left_7.png" />
                      </span>
                    </span>
                  </div>
                  <div
                    class="colorBlock"
                    v-if="
                      !print_areas.filter(item => {
                        return item.view_id === activeDesign && item.design_style
                      }).length
                    "
                    @click="showColor"
                    :style="{ background: colors.hex }"
                  ></div>
                  <div
                    v-show="colorShow"
                    class="colorWrap setColorBtnCss"
                    @mouseleave="
                      colorShow = false
                      setRandom()
                    "
                  >
                    <Sketch v-model="colors" @input="inputColor" />
                    <div class="btn" @click="addUserColorsFn(colors.hex)">
                      {{ $t('design.addToCustomColor') }}
                    </div>
                  </div>
                </div>
                <ConfigColors
                  v-if="
                    !print_areas.filter(item => {
                      return item.view_id === activeDesign && item.design_style
                    }).length
                  "
                  :userConfigColors="userConfigColors"
                  @change="getUserColorsFn()"
                  @upColor="
                    data => {
                      inputColor({ hex: data })
                    }
                  "
                  :type="'text'"
                ></ConfigColors>
              </template>
            </div>
          </div>
        </div>
        <div class="sidebarHide" v-show="menuLeftIndex === 3">
          <div class="hideBox">
            <div class="sidebarHead">
              <div
                class="canvasColor"
                v-if="
                  !print_areas.filter(item => {
                    return item.view_id === activeDesign && item.design_style
                  }).length
                "
              >
                <div class="canvasColorInner">
                  <div class="coverBackgroundColorWrap">
                    <Sketch v-model="backgroundColor" @input="inputBackgroundColor" />
                  </div>
                </div>
                <div class="myBut">
                  <!-- <span class="bgColorWrap" :class="{ maxWidth: isSwitch }">{{ backgroundColor || '' }}</span> -->
                  <a-input
                    class="bgColorWrap"
                    v-model="backgroundColor"
                    @blur="setBgColor"
                    :class="{ maxWidth: isSwitch }"
                  ></a-input>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>{{ $t('design.takeColor') }}</span>
                    </template>
                    <i class="iconfont icon-quseqi" @click="showColorPickModal"></i>
                  </a-tooltip>
                  <span
                    class="colorSelectSp"
                    style="background: #ff0000"
                    @click="inputBackgroundColor({ hex8: '#FF0000' })"
                  ></span>
                  <span
                    class="colorSelectSp"
                    style="background: #0a6cff"
                    @click="inputBackgroundColor({ hex8: '#0A6CFF' })"
                  ></span>
                  <span
                    class="colorSelectSp"
                    style="background: #ffc400"
                    @click="inputBackgroundColor({ hex8: '#FFC400' })"
                  ></span>
                  <a class="bgColorReset" @click="inputBackgroundColor({ hex8: '#00000000' })">{{
                    $t('generic.reset')
                  }}</a>
                </div>
                <div class="setColorBtn" @click="addUserColorsFn(backgroundColor)">
                  {{ $t('design.addToCustomColor') }}
                </div>
                <div class="colorSelectBlock">
                  <h5>{{ $t('design.presetColor') }}</h5>
                  <div class="clearFix colorSelectBox">
                    <div
                      class="colorSelect"
                      style="background: #ff0000"
                      @click="inputBackgroundColor({ hex8: '#FF0000' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #ef8aff"
                      @click="inputBackgroundColor({ hex8: '#EF8AFF' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #add802"
                      @click="inputBackgroundColor({ hex8: '#ADD802' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #00ff19"
                      @click="inputBackgroundColor({ hex8: '#00FF19' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #00b3ff"
                      @click="inputBackgroundColor({ hex8: '#00B3FF' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #0000ff"
                      @click="inputBackgroundColor({ hex8: '#0000FF' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #2f7e02"
                      @click="inputBackgroundColor({ hex8: '#2F7E02' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #c40202"
                      @click="inputBackgroundColor({ hex8: '#C40202' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #ff8800"
                      @click="inputBackgroundColor({ hex8: '#FF8800' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #7f9cfb"
                      @click="inputBackgroundColor({ hex8: '#7F9CFB' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #ff8e8e"
                      @click="inputBackgroundColor({ hex8: '#FF8E8E' })"
                    ></div>
                    <div
                      class="colorSelect"
                      style="background: #5fc35f"
                      @click="inputBackgroundColor({ hex8: '#5FC35F' })"
                    ></div>
                  </div>
                </div>
                <ConfigColors
                  :userConfigColors="userConfigColors"
                  @upBg="
                    data => {
                      inputBackgroundColor({ hex8: data })
                    }
                  "
                  @change="getUserColorsFn()"
                ></ConfigColors>
              </div>
              <div class="notCanvasColor" v-else>
                {{ $t('design.notSupportColor') }}
              </div>
            </div>
          </div>
        </div>
        <!-- 图层 -->
        <div class="sidebarAuto" v-show="isShowLayers">
          <div class="layersTitle">
            {{ $t('design.layer') }}
            <a-icon class="closeBtn" type="close" @click="isShowLayers = false" />
          </div>
          <div class="tcHidden">
            <div class="layersCt" v-if="activeFabric ? activeFabric.layers.length !== 0 : false">
              <div
                v-for="(value, index) in activeFabric ? activeFabric.layers : []"
                :key="index"
                @click="activeLayersOnClick(index)"
                :class="{
                  layerItem: true,
                  hover: true
                }"
                v-show="value.type !== 'group'"
              >
                <div style="height: 100%; width: 40px" v-if="value.type === 'image'">
                  <ImgLoading :src="value.src" height="100%" width="100%" />
                </div>
                <span v-else-if="value.type === 'text'" style="font-weight: bolder">{{ $t('design.text') }}</span>
                <div class="controlLayer">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>{{ $t('generic.copy') }}</span>
                    </template>
                    <div class="copy">
                      <a-icon type="copy" @click.stop="copyLayer(index)" />
                    </div>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>{{ $t('generic.hide') }}</span>
                    </template>
                    <div class="noShow">
                      <a-icon type="eye" @click.stop="hiddenLayer(index, value)" v-if="!!value.visible" />
                      <a-icon type="eye-invisible" v-else @click.stop="hiddenLayer(index, value)" />
                    </div>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>{{ $t('generic.delete') }}</span>
                    </template>
                    <div class="del">
                      <a-icon type="delete" @click.stop="delLayer(index)" />
                    </div>
                  </a-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ColorPickModal
      ref="ColorPickModal"
      @change="
        data => {
          inputBackgroundColor({ hex8: data })
          $refs.ColorPickModal.visible = false
        }
      "
    />
    <NewUpload
      ref="uploadModal"
      :url="'/distribution/material'"
      :delUrl="'/distribution/material/deletes'"
      @getUploaderList="getUploaderList"
    />
    <a-modal
      :visible="productVisible"
      @cancel="
        () => {
          productVisible = false
        }
      "
      :getContainer="() => document.getElementById('app')"
      width="1048px"
      title="Product details"
      :footer="null"
      :destroyOnClose="true"
    >
      <div class="productModal">
        <div class="cpBlock clearFix">
          <div class="cpImgBox">
            <ImgLoading :src="printImgInfo.product_show_master_image" />
          </div>
          <div class="cpInfoBox">
            <p class="name">
              {{ printImgInfo.en_name }}
            </p>
            <p class="code clearFix">(Product Code: {{ printImgInfo.code }})</p>
            <p class="money clearFix">
              <span class="price"
                >{{
                  (priceData.is_promotion === 1 ? priceData.promotion_price : priceData.purchase_price)
                    | rateAmountLocal
                }}<span class="old_pricce" v-if="priceData.is_promotion === 1">{{
                  priceData.purchase_price | rateAmountLocal
                }}</span></span
              >
              <span v-if="priceData.is_promotion === 1" class="promotion_percent">
                -{{
                  (
                    ((Number(priceData.purchase_price) - Number(priceData.promotion_price)) /
                      priceData.purchase_price) *
                    100
                  ).toFixed(0)
                }}%
              </span>
            </p>
          </div>
        </div>
        <div class="tabBlock">
          <div class="tabItem" :class="{ on: productIndex === 0 }" @click="productIndex = 0">Product information</div>
          <div class="tabItem" :class="{ on: productIndex === 1 }" @click="productIndex = 1">Product size</div>
          <div class="tabItem" :class="{ on: productIndex === 2 }" @click="productIndex = 2">Packing specification</div>
          <!-- <div class="tabItem" :class="{ on: productIndex === 3 }" @click="productIndex = 3">FBA装箱建议</div> -->
          <div class="tabItem" :class="{ on: productIndex === 4 }" @click="productIndex = 4">
            Similar recommendation
          </div>
        </div>
        <div class="productBody">
          <div v-show="productIndex === 0">
            <div class="row-div">
              <div class="rowTitle">Basic information</div>
              <a-row type="flex">
                <a-col :span="12">
                  <span>{{ $t('generic.enName') }}: {{ printImgInfo.en_name }}</span>
                </a-col>
                <a-col :span="12">
                  <span>{{ $t('generic.productCode') }}: {{ printImgInfo.code }}</span>
                </a-col>
                <a-col :span="12">
                  <span>{{ $t('generic.productionTechnolegy') }}: {{ printImgInfo.product_technology_text }}</span>
                </a-col>
                <a-col :span="12">
                  <span>{{ $t('generic.productMaterial') }}: {{ printImgInfo.product_material_text }}</span>
                </a-col>
              </a-row>
            </div>
            <div class="rowTitle">Product description</div>
            <!-- <div class="tips-div" v-html="printImgInfo.desc"></div> -->
            <div class="tips-div" v-html="printImgInfo.en_desc"></div>
          </div>
        </div>
        <div v-show="productIndex === 1">
          <template v-if="printImgInfo.attr_values && printImgInfo.attr_values.length">
            <div class="size-wrap">
              <div class="size-head">
                <div class="head-item">{{ $t('generic.size') }}</div>
                <template v-if="printImgInfo.attr_values[0].attr_value">
                  <div class="head-item" v-for="(item, i) in printImgInfo.attr_values[0].attr_value" :key="i">
                    {{ item.attr_name }}
                  </div>
                </template>
              </div>
              <div class="size-body" v-for="(item, i) in printImgInfo.attr_values" :key="i">
                <div class="body-item">{{ item.size_name }}</div>
                <template v-if="item.attr_value">
                  <div class="body-item" v-for="(it, x) in item.attr_value" :key="x">{{ it.attr_value }}</div>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <a-empty style="margin-top: 30px" />
          </template>
        </div>
        <div v-show="productIndex === 2">
          <template v-if="printImgInfo.size_specifications && printImgInfo.size_specifications.length">
            <div class="size-wrap">
              <div class="size-head">
                <div class="head-item w25">Size</div>
                <div class="head-item w25">Package size(cm)</div>
                <div class="head-item w25">Packaging volume(cm*3)</div>

                <div class="head-item w25">Inner packing weight(g)</div>
                <div class="head-item w25">Outer packing weight(g)</div>
                <div class="head-item w25">Number of packaged products(Max)</div>
              </div>
              <div class="size-body" v-for="(item, i) in printImgInfo.size_specifications" :key="i">
                <div class="body-item w25">{{ item.size_name }}</div>
                <div class="body-item w25">long:{{ item.length }} width:{{ item.width }} height:{{ item.height }}</div>
                <div class="body-item w25">{{ item.volume }}</div>

                <div class="body-item w25">{{ item.inner_package_weight }}</div>
                <div class="body-item w25">{{ item.outer_package_weight }}</div>
                <div class="body-item w25">{{ item.packaged_item_num }}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <a-empty style="margin-top: 30px" />
          </template>
        </div>
        <div v-show="productIndex === 4">
          <SameSwiper v-if="productVisible" :categoryId="printImgInfo.stock_sku.category_id"></SameSwiper>
        </div>
        <!-- <div class="footer-btn">
          <span>
          </span>
          <span>
            <a-button @click="productVisible = false">关闭</a-button>
          </span>
        </div> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import NewUpload from '@/views/components/newUpload'
import SameSwiper from '@/views/goodsLibrary/component/sameSwiper.vue'
import ImgLoading from '@/views/components/imgLoading'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
// getImgList,
import {
  getDesignImgList,
  getUserCategory,
  getPurchasePrice,
  getCategoryImgList,
  getUserColors,
  addUserColors
} from '@/api/design'
import * as cc from 'my-design-canvas/desf4fc'
import { Sketch } from 'vue-color'
import { getStockSkuCategory } from '@/api/gruopDesign/index'
import TreeSelect from './TreeSelect.js'
import RenderTree from './tree.js'
import { getUserMaterialCategory, getMaterialCategory } from '@/api/openGallery'
import { getUserMap } from '@/api/orderAdmin'
// eslint-disable-next-line no-unused-vars
import { getVolume } from '@/api/globalGde'
import ColorPickModal from './colorPickModal'
import ConfigColors from './configColors'
import { saveHistory, getFabricScale } from '@/utils/util.js'
import store from '@/store'
cc.Object.prototype.objectCaching = false

export default {
  name: 'LeftWrap',
  data() {
    return {
      userConfigColors: [],
      categorySelect: [],
      wholesaleColumns: [
        {
          title: '起批量(件)',
          dataIndex: 'num',
          align: 'center',
          scopedSlots: { customRender: 'num' }
        },
        {
          title: '订购价($)',
          dataIndex: 'amount',
          align: 'center'
        }
      ],
      isSwitch: false,
      customerTreeVisible: false,
      treeVisible: false,
      productVisible: false,
      boxIndex: 0,
      productIndex: 0,
      treeData: [],
      userCategoryTreeData: [],
      isCategoryId: false,
      treeData2: [],
      designImgList: [],
      isGroup: true,
      imgList: [],
      imgId: '',
      userMap: [],
      fontSizeData: [
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50
      ],
      fontList: [
        'Hanalei Fill',
        'Kirang Haerang',
        'Slabo 27px',
        'Do Hyeon',
        'MedievalSharp',
        'Indie Flower',
        'Ruslan Display',
        'Anton',
        'Fjalla One',
        'Lobster',
        'Abel',
        'Pacifico',
        'Arial Black',
        'BankGothic Md BT',
        // 'comici',
        'Comic Sans MS',
        'Hobo Std',
        'Futura Black BT',
        'GoudyHandtooled BT',
        'Lithograph',
        'Monotype Corsiva',
        'MoolBoran',
        'Times New Roman',
        // 'Times New Roman 400',
        'Bremen Bd BT',
        'Arial',
        'Georgia',
        'Helvetica',
        'Verdana',
        'Great Vibes',
        'Bad Script',
        'Cookie',
        'Cantarell',
        'Bikham Cyr Script',
        'Righteous',
        'Bebas Neue',
        'Spooky Witchy',
        'Champagne & Limousines',
        'LEMON MILK',
        'LaserMetal',
        'bhatoshine',
        'bhatoshai caps',
        'extras',
        'Angelface',
        'AeroliteScriptCP',
        'AeroliteScriptCP2',
        'ALISEO',
        'Rustling Trees',
        'Arrose',
        'AVENIDA',
        'Fiolex Girls',
        'Gabriela Ragile',
        'Love Plants',
        'Vidaloka',
        'VnBook-Antiqua',
        'Futura-Bold',
        'VnCourier New',
        'El Mayor Free Trial',
        'Algerian',
        'Ayar Juno',
        'Berkshire Swash',
        'Duvall',
        'Humeira,Humeira Bold',
        'Impact',
        'Spooky Halloween',
        'Gods own junkyard',
        'Mawoot',
        'Archivo Black',
        'Lato',
        'Ultra',
        'Abril Fatface',
        'Monoton',
        'Luckiest Guy',
        'Rock Salt',
        'Permanent Marker',
        'All the Way to the Sun',
        'Avenir',
        'Avenir 65',
        'Cantata One',
        'Rubik Mono One',
        'orbitron',
        'Audiowide',
        'Syncopate',
        'QuentinCaps',
        'Planet Benson 2',
        'Funk',
        'Deftone Stylus',
        'Bradley Gratis',
        'a Alloy Ink',
        'Hallo Carthy',
        'Heartless Valiumwhore',
        'Panton Rust Black'
      ],
      menuLeftIndex: 0,
      menuLeft: [
        {
          name: this.$t('design.product')
        },
        {
          name: this.$t('design.gallery')
        },
        {
          name: this.$t('design.text')
        },
        {
          name: this.$t('design.background')
        },
        {
          name: this.$t('design.layer')
        }
      ],
      cmToInch: 0.3937008,
      menuList: [],
      searchCondition: {
        keyword: '',
        page: 1,
        category_id: 0,
        is_customer_category: 0,
        total: 1,
        per_page: 16
      },
      isDesigned: [
        {
          id: '',
          name: this.$t('design.designOrNot')
        },
        {
          id: 1,
          name: this.$t('design.designed')
        },
        {
          id: -1,
          name: this.$t('design.notDesigned')
        }
      ],
      shapeData: [
        {
          id: '',
          name: this.$t('design.pictureShape')
        },
        {
          id: 1,
          name: this.$t('design.quasiSquare')
        },
        {
          id: 2,
          name: this.$t('design.transverseShape')
        },
        {
          id: 3,
          name: this.$t('design.verticalShape')
        },
        {
          id: 4,
          name: this.$t('design.superTransverseShape')
        },
        {
          id: 5,
          name: this.$t('design.superVerticalShape')
        }
      ],
      searchCondition2: {
        shape: '',
        is_designed: '',
        tags: '',
        name: '',
        page: 1,
        customer_category_id: 0,
        category_id: 0,
        total: 1,
        is_system: 0,
        per_page: 16,
        user_id: ''
      },
      customerData: {
        customer_category_id: 0
      },
      moreShow: false,
      colors: {
        hex: '#000000',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.3, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
      },
      backgroundShow: false,
      isShowDetail: false,
      isShowLayers: false,
      backgroundColor: '#000000',
      colorShow: false,
      canAddImg: false // 是否允许拖拽加入图片
    }
  },

  components: {
    Sketch,
    NewUpload,
    TreeSelect,
    ColorPickModal,
    RenderTree,
    SameSwiper,
    ConfigColors,
    ImgLoading
  },

  props: ['configData', 'orderKeyword'],
  created() {
    // 初始化图片数组
    this.setOriginalImgList([])
    if (!this.configData.showProduct || this.configData.isReDesign) {
      this.setActiveTab(2)
      this.imgId = this.configData.id
      if (this.configData.showReturn) {
        this.getImgListMethod({
          ...this.searchCondition,
          page: 1,
          per_page: 16,
          keyword: this.orderKeyword ? this.orderKeyword : ''
        })
        this.GetSingleImgInfo(
          this.$route.params.code
            ? this.$route.params.code
            : this.orderKeyword
            ? this.orderKeyword
            : this.$ls.get('productId') === null
            ? 123
            : this.$ls.get('productId')
        ).then(data => {
          this.imgId = data.id
          console.log('this.$route.params===2222222', this.$route.params)
          if (this.$route.params && this.$route.params.code) {
            this.$emit('upIsShowDetail')
          }
          if (this.$route.params && this.$route.params.imgData) {
            this.setActiveTab(2)
            this.addImgToFabric(this.$route.params.imgData)
          }
        })
      }
    } else {
      // this.getImgListMethod({
      //   page: 1,
      //   per_page: 15,
      //   keyword: this.$route.params.code ? this.$route.params.code : this.orderKeyword ? this.orderKeyword : undefined
      // })
      this.getImgListMethod({
        ...this.searchCondition,
        page: 1,
        per_page: 16,
        keyword: this.orderKeyword ? this.orderKeyword : ''
      })
      this.GetSingleImgInfo(
        this.$route.params.code
          ? this.$route.params.code
          : this.orderKeyword
          ? this.orderKeyword
          : this.$ls.get('productId') === null
          ? 123
          : this.$ls.get('productId')
      ).then(data => {
        this.imgId = data.id
        console.log('this.$route.params===2222222', this.$route.params)
        if (this.$route.params && this.$route.params.code) {
          this.$emit('upIsShowDetail')
        }
        if (this.$route.params && this.$route.params.imgData) {
          this.setActiveTab(2)
          this.addImgToFabric(this.$route.params.imgData)
        }
      })
    }
    // this.searchCondition.keyword = this.$route.params.code
    //   ? this.$route.params.code
    //   : this.orderKeyword
    //   ? this.orderKeyword
    //   : ''
    this.searchCondition.keyword = this.orderKeyword ? this.orderKeyword : ''
    getMaterialCategory().then(res => {
      this.menuList = res.data
    })
    // 获取素材接口
    this.getDesignImgListMethod({
      page: 1,
      per_page: 16
    })
    getStockSkuCategory().then(res => {
      this.treeData = res.data
    })
    getUserCategory().then(res => {
      this.userCategoryTreeData = res.data
    })
    getUserMaterialCategory().then(res => {
      this.treeData2 = res.data
    })
    getUserMap({ type: 3, is_arr: 1 }).then(res => {
      this.searchCondition2.user_id = res.data[0].id
      this.userMap = res.data
      this.GetUserMaterialTag({ user_id: this.searchCondition2.user_id, show_num: 1 })
    })
    this.getUserColorsFn()
  },
  watch: {
    'searchCondition.category_id'() {
      this.getImgListMethod({ ...this.searchCondition, page: 1 })
    },

    'customerData.customer_category_id'() {
      if (+this.searchCondition2.is_system === 0) {
        this.searchCondition2.category_id = 0
        this.searchCondition2.customer_category_id = this.customerData.customer_category_id
      } else {
        this.searchCondition2.category_id = this.customerData.customer_category_id
        this.searchCondition2.customer_category_id = 0
      }
      this.getDesignImgListMethod({
        ...this.searchCondition2,
        page: 1
      })
    }
  },
  computed: {
    ...mapState({
      allTags: state => state.myGallery.allTags,
      activeTab: state => state.design.activeTab,
      activeDesign: state => state.design.activeDesign,
      fabricList: state => state.design.fabricList,
      syncOtherSide: state => state.design.syncOtherSide,
      font: state => state.design.font,
      fontSize: state => state.design.fontSize,
      textValue: state => state.design.textValue,
      designStyle: state => state.design.designStyle,
      printImgInfo: state => state.design.printImgInfo,
      initialSize: state => state.design.initialSize,
      print_areas: state => state.design.print_areas,
      basic_product_id: state => state.design.basic_product_id,
      initialColor: state => state.design.initialColor,
      priceData: state => state.design.priceData,
      originalImgList: state => state.design.originalImgList
    }),
    ...mapGetters(['activeFabric', 'activePrintAreas', 'canvasType', 'getToken'])
  },
  beforeDestroy() {},
  methods: {
    ...mapActions(['GetSingleImgInfo', 'GetUserMaterialTag']),
    ...mapMutations({
      setRandom: 'SET_RANDOM',
      setTextValue: 'SET_TEXT_VALUE',
      setActiveTab: 'SET_ACTIVE_TAB',
      setBasicProductId: 'SET_BASIC_PRODUCT_ID',
      setShowImgDetail: 'SET_SHOW_IMG_DETAIL',
      setShowImgDetailData: 'SET_SHOW_IMG_DETAIL_DATA',
      setFont: 'SET_FONT',
      setFontSize: 'SET_FONT_SIZE',
      setTipLevel: 'SET_TIP_LEVEL',
      setInitTipLevel: 'SET_INIT_TIP_LEVEL',
      setCopyProductId: 'SET_COPY_PRODUCT_ID',
      setPrice: 'SET_PRICE',
      setColor: 'SET_INITIAL_COLOR',
      setSize: 'SET_INITIAL_SIZE',
      setCanvasType: 'SET_CANVAS_TYPE',
      setGifVisible: 'SET_GIF_VISIBLE',
      setOriginalImgList: 'SET_ORIGINAL_IMG_LIST'
    }),
    addUserColorsFn(data) {
      if (!data) {
        return
      }
      addUserColors({ user_colors: data }).then(res => {
        this.getUserColorsFn()
      })
    },
    getUserColorsFn() {
      getUserColors().then(res => {
        this.userConfigColors = res.data.user_colors || []
        console.log('ruserConfigColorses==', this.userConfigColors)
      })
    },
    addCategory(item) {
      this.categorySelect.push({ name: item.name, id: item.id })
      this.searchCondition.category_id = item.id
      console.log('categorySelect', this.categorySelect)
    },
    spliceCategory() {
      if (this.categorySelect.length === 1) {
        this.categorySelect = []
        this.searchCondition.category_id = 0
      } else {
        this.categorySelect.splice(this.categorySelect.length - 1, 1)
        this.searchCondition.category_id = this.categorySelect[this.categorySelect.length - 1].id
      }
      console.log('categorySelect===', this.categorySelect)
    },
    handleClickChange(val) {
      this.treeVisible = val
    },
    customerTreeVisibleChange(val) {
      this.customerTreeVisible = val
    },
    changeSize(val) {
      if (+val === +this.initialSize) {
        return
      }
      this.setSize(val)
      this.$nextTick(() => {
        getPurchasePrice({
          id: this.basic_product_id,
          data: { size_id: this.initialSize, color_id: this.initialColor }
        }).then(res => {
          this.setPrice(res.data)
        })
      })
    },
    changeColor(val) {
      if (+val === +this.initialColor) {
        return
      }
      this.setColor(val)
      this.$nextTick(() => {
        getPurchasePrice({
          id: this.basic_product_id,
          data: { size_id: this.initialSize, color_id: this.initialColor }
        }).then(res => {
          this.setPrice(res.data)
        })
      })
      this.setRandom()
    },
    showFn() {
      console.log('printImgInfo===', this.printImgInfo)
    },
    menuLeftChange(i) {
      if (i === 4) {
        this.isShowLayers = !this.isShowLayers
      } else {
        this.menuLeftIndex = i
      }
      console.log('print_areas=====1', this.print_areas)
      console.log('fabricList=====1', this.fabricList)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    showColorPickModal() {
      this.drawImgToCanvas(this.activeFabric.toDataURL())
    },
    createCanvas() {
      const canvas = document.createElement('canvas')
      canvas.height = 700
      canvas.width = 700
      return canvas
    },
    isCategoryChange(value) {
      this.searchCondition.is_customer_category = value
      if (this.searchCondition.category_id === 0) {
        this.getImgListMethod({ ...this.searchCondition, page: 1 })
      } else {
        this.searchCondition.category_id = 0
      }
    },
    isSystemChange(value) {
      this.searchCondition2.is_system = value
      if (this.customerData.customer_category_id === 0) {
        this.getDesignImgListMethod({
          ...this.searchCondition2,
          page: 1
        })
      } else {
        this.customerData.customer_category_id = 0
      }
    },
    drawImgToCanvas(src) {
      const canvas = this.createCanvas()
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = src
      img.onload = () => {
        ctx.drawImage(img, 0, 0)
        const { ColorPickModal } = this.$refs
        ColorPickModal.visible = true
        ColorPickModal.src = src
        ColorPickModal.ctx = ctx
      }
    },
    userMapChange(e) {
      this.searchCondition2.user_id = e
      this.GetUserMaterialTag({ user_id: this.searchCondition2.user_id, show_num: 1 })
      getUserMaterialCategory({ user_id: e }).then(res => {
        this.treeData2 = res.data
      })
      this.getDesignImgListMethod({ ...this.searchCondition2 })
    },
    changeFontSizeSelect(e) {
      const activeObject = this.activeFabric.getActiveObject()
      console.log('activeObject===', activeObject)
      if (!activeObject || activeObject.type !== 'text') {
        return
      }
      if (activeObject.type === 'text') {
        activeObject.set('fontSize', e)
        this.setFontSize(e)
      }

      this.activeFabric.renderAll()
      this.setRandom()
    },
    textValueChange(e) {
      const activeObject = this.activeFabric.getActiveObject()
      this.setTextValue(e.target.value)
      if (activeObject && activeObject.type === 'text') {
        activeObject.set('text', e.target.value)
        this.activeFabric.renderAll()
        this.setRandom()
      } else {
        this.$message.warning('Please select text')
      }
    },
    changeFontSize(type) {
      const activeObject = this.activeFabric.getActiveObject()
      console.log('activeObject===', activeObject)
      if (!activeObject || activeObject.type !== 'text') {
        return
      }
      if (activeObject.type === 'text') {
        const fontSize = activeObject.fontSize
        if (type === 'minus') {
          activeObject.set('fontSize', fontSize - 1)
          this.setFontSize(fontSize - 1)
        }
        if (type === 'plus') {
          activeObject.set('fontSize', fontSize + 1)
          this.setFontSize(fontSize + 1)
        }
        this.activeFabric.renderAll()
        this.setRandom()
      }
    },
    showImgDetailMethod(row) {
      // console.log(row)
      // this.showImgDetailData = row
      // this.showImgDetail = true
      this.setShowImgDetail(true)
      this.setShowImgDetailData(row)
    },
    getVolumeMethod() {
      this.$refs.uploadModal.visible = true
      // getVolume().then((res) => {
      //   if (res.data.is_over_material_capacity === 1) {
      //     this.$message.error('图库容量不足!')
      //   } else {
      //     this.$refs.uploadModal.visible = true
      //   }
      // })
    },
    hiddenLayer(index, value) {
      value.visible = !value.visible
      const activeImg = this.activeFabric.item(index)
      const objects = this.activeFabric.getObjects()
      const group = objects.find(item => item.time === activeImg.time && item.type === 'group')
      this.$nextTick(() => {
        activeImg.visible = value.visible
        if (group) {
          group.visible = value.visible
        }
        this.activeFabric.renderAll()
        this.setRandom()
      })
    },
    delLayer(index) {
      const activeImg = this.activeFabric.item(index)
      this.activeFabric.remove(activeImg)
      this.activeFabric.renderAll()
    },
    copyLayer(index) {
      const forClone = this.activeFabric.item(index)
      forClone.clone(cloned => {
        cloned.left += 20
        cloned.top += 20
        cloned.material_code = forClone.material_code
        cloned.vision_type = forClone.vision_type
        cloned.vision_oss_file_id = forClone.vision_oss_file_id
        this.activeFabric.add(cloned)
        this.setRandom()
      })
    },
    activeLayersOnClick(index) {
      const activeImg = this.activeFabric.item(index)
      console.log('activeImg====1111', activeImg.type)
      this.setCanvasType(activeImg.type || '')
      this.activeFabric.setActiveObject(activeImg)
      this.activeFabric.renderAll()
      if (activeImg.type === 'text') {
        this.menuLeftIndex = 2
      }
    },
    getUploaderList() {
      this.getDesignImgListMethod(this.searchCondition2)
    },
    changeImg(e, value, darkValue) {
      const src = e.target.src
      if (src === require('@/assets/design/' + darkValue + '.png')) {
        e.target.src = require('@/assets/design/' + value + '.png')
      } else {
        e.target.src = require('@/assets/design/' + darkValue + '.png')
      }
    },
    changFont(val) {
      const activeObject = this.activeFabric.getActiveObject()
      this.setFont(val)
      if (!activeObject) {
        return
      }
      if (activeObject.type === 'text') {
        activeObject.set('fontFamily', val)
        // activeObject.set('fontWeight', 'bolder')
        this.activeFabric.renderAll()
        this.setRandom()
      }
    },
    inputColor(val) {
      console.log('val====11111111', val)
      console.log('colors====1111111', this.colors)
      const activeObject = this.activeFabric.getActiveObject()
      if (activeObject && activeObject.type === 'text') {
        activeObject.set('fill', val.hex)
        this.activeFabric.renderAll()
        this.setRandom()
      }
    },
    setRgbTo16(str) {
      const reg = /^(rgb|RGB|rgba)/
      if (!reg.test(str)) {
        return
      }
      var arr = str.slice(4, str.length - 1).split(',')
      let color = '#'
      for (var i = 0; i < arr.length; i++) {
        var t = Number(arr[i]).toString(16)
        if (t === '0') {
          // 如果为“0”的话，需要补0操作,否则只有5位数
          t = t + '0'
        }
        color += t
      }
      return color
    },
    setBgColor() {
      if (!this.backgroundColor) {
        return
      }
      let bgColor = this.backgroundColor
      if (this.backgroundColor.indexOf('#') === -1) {
        bgColor = `#${this.backgroundColor}`
      }
      this.inputBackgroundColor({ hex8: bgColor })
    },
    inputBackgroundColor(val) {
      this.activeFabric.setBackgroundColor(val.hex8 || val.hex, this.activeFabric.renderAll.bind(this.activeFabric))
      console.log('activeFabric===1111', this.activeFabric)
      this.backgroundColor = val.hex8 || val.hex
      this.setGifVisible(false)
      this.activeFabric.renderAll()
      this.setRandom()
    },
    getBackgroundColor() {
      console.log('activeFabric===1111', this.activeFabric)
      if (this.activeFabric && this.activeFabric.backgroundColor) {
        this.backgroundColor = this.activeFabric.backgroundColor
      } else {
        this.backgroundColor = '#00000000'
      }
    },
    showBackgroundColor() {
      // this.backgroundShow ? (this.backgroundShow = false) : (this.backgroundShow = true)
      this.backgroundShow = !this.backgroundShow
    },
    showColor() {
      // this.colorShow ? (this.colorShow = false) : (this.colorShow = true)
      this.colorShow = !this.colorShow
    },
    addFontInToFabric() {
      // this.setActiveTab(3)
      const time = new Date().getTime()
      const styleObj = this.print_areas.find(it => {
        return it.view_id === this.activeDesign
      })
      const text = new cc.Text(this.$t('generic.enterContent'), {
        left: 275,
        top: 275,
        fontFamily: this.font,
        fontSize: 30,
        fill: styleObj.design_style || '#000000',
        originX: 'center',
        originY: 'center',
        charSpacing: 1,
        time
      })

      this.setTextValue(this.$t('generic.enterContent'))
      this.activeFabric.add(text)
      this.activeFabric.setActiveObject(text)
      this.activeFabric.renderAll()
      this.setCanvasType('text')
      this.setGifVisible(false)
      this.setRandom()
      saveHistory()
    },
    async addImgToFabric(value) {
      console.log(value)
      store.commit('SET_LOADING', true)
      if (this.syncOtherSide) {
        const tipLevels = {}
        for (let i = 0; i < this.fabricList.length; i++) {
          const activeFabric = this.fabricList[i].canObj
          await new Promise(resolve => {
            cc.Image.fromURL(
              value.big_image_src,
              img => {
                img.scale(getFabricScale(this.activePrintAreas, img))
                const time = new Date().getTime()
                img.set({
                  material_code: value.code,
                  oss_file_id: value.oss_file_id,
                  material_id: value.id,
                  time,
                  pxH: value.height,
                  pxW: value.width,
                  tipLevel: 0,
                  left: 275,
                  top: 275,
                  originX: 'center',
                  originY: 'center'
                })
                const { view_id } = this.fabricList[i]
                tipLevels[view_id] = this.getScaleInfo(img, view_id, this.initialSize)
                const styleObj = this.print_areas.find(it => {
                  return it.view_id === view_id
                })
                if (styleObj.design_style) {
                  this.applyFilters(img, styleObj.design_style)
                }
                activeFabric.add(img)

                activeFabric.setActiveObject(img)
                activeFabric.renderAll()
                resolve()
              },
              { crossOrigin: 'anonymous' }
            )
          })
        }
        this.setInitTipLevel(tipLevels)
      } else {
        await new Promise(resolve => {
          cc.Image.fromURL(
            value.big_image_src,
            img => {
              img.scale(getFabricScale(this.activePrintAreas, img))

              const time = new Date().getTime()
              img.set({
                material_code: value.code,
                oss_file_id: value.oss_file_id,
                material_id: value.id,
                time,
                pxH: value.height,
                pxW: value.width,
                tipLevel: 0,
                left: 275,
                top: 275,
                originX: 'center',
                originY: 'center'
              })
              const tipLevel = this.getScaleInfo(img, this.activeDesign, this.initialSize)
              this.setTipLevel(tipLevel)
              // this.designStyle !== '' &&
              //   this.designStyle !== '0' &&
              //   this.designStyle !== '1' &&
              //   this.designStyle !== '2' &&
              //   this.applyFilters(img)
              const styleObj = this.print_areas.find(it => {
                return it.view_id === this.activeDesign
              })
              if (styleObj.design_style) {
                this.applyFilters(img, styleObj.design_style)
              }
              this.activeFabric.add(img)

              this.activeFabric.setActiveObject(img)
              this.activeFabric.renderAll()
              resolve()
            },
            { crossOrigin: 'anonymous' }
          )
        })
      }
      this.originalImgList.push({
        id: value.id,
        src: value.big_image_src,
        design_oss_file_id: value.design_oss_file_id
      })
      this.setOriginalImgList(this.originalImgList)
      this.$emit('upRotatedNum', 0)
      this.setCanvasType('image')
      this.setGifVisible(false)
      saveHistory()
      this.setRandom()
      setTimeout(() => {
        store.commit('SET_LOADING', false)
      }, 500)
    },
    getTip(deforLevelH, deforLevelW) {
      const whichTip = deforLevelW >= deforLevelH ? deforLevelW : deforLevelH
      if (whichTip > 0 && whichTip < 0.1) {
        return 1
      }
      if (whichTip > 0.1 && whichTip < 0.4) {
        return 2
      }
      if (whichTip > 0.4) {
        return 3
      }
      return 0
    },
    getOnePxToRealWidth(activeDesign, initialSize) {
      const { actual_sizes } = this.printImgInfo
      const actualSizeObj = actual_sizes.find(item => item.view_id === activeDesign && item.size_id === initialSize)
      const printAreas = this.print_areas.find(item => item.view_id === activeDesign)
      const onePxToRealWidth = parseInt(actualSizeObj.actual_width) / parseInt(printAreas.width)
      // this.onePxToRealWidth = onePxToRealWidth
      return onePxToRealWidth
    },
    getScaleInfo(e, activeDesign, initialSize) {
      const onePxToRealWidth = this.getOnePxToRealWidth(activeDesign, initialSize)
      const { height, width, scaleX, scaleY, pxH, pxW } = e
      const { dpi } = this.printImgInfo
      const realHeight = (height * scaleY * onePxToRealWidth * this.cmToInch) / 10
      const realWidth = (width * scaleX * onePxToRealWidth * this.cmToInch) / 10
      // console.log(pxH / realHeight.toFixed(0), pxW / realWidth.toFixed(0))
      const deforLevelH = dpi - pxH / realHeight.toFixed(0) <= 0 ? 0 : dpi - pxH / realHeight.toFixed(0)
      const deforLevelW = dpi - pxW / realWidth.toFixed(0) <= 0 ? 0 : dpi - pxW / realWidth.toFixed(0)
      return this.getTip(deforLevelH / dpi, deforLevelW / dpi)
    },
    applyFilters(img, designStyle) {
      // img.filters.push(new cc.Image.filters.BlackWhite())
      img.filters.push(
        new cc.Image.filters.BlendColor({
          color: designStyle,
          mode: 'tint'
        })
      )
      img.applyFilters()
    },
    getImgListMethod(params) {
      delete params.total
      params.design_mode = 1
      console.log('params===', params)
      // getImgList(params).then(res => {
      //   // this.imgList = res.data.data
      //   this.searchCondition.page = res.data.current_page || 1
      //   this.searchCondition.total = res.data.total || 0
      // })
      getCategoryImgList(params).then(res => {
        console.log('xxx=====1=====', res)
        if (res.data.current_page) {
          this.isGroup = false
          this.imgList = res.data.data
        } else {
          this.isGroup = true
          this.imgList = res.data
        }

        this.searchCondition.page = res.data.current_page || 1
        this.searchCondition.total = res.data.total || 0
      })
    },
    getDesignImgListMethod(params) {
      delete params.total
      params.basic_product_id = this.imgId || this.printImgInfo.id
      console.log('printImgInfo====', this.printImgInfo.id)
      getDesignImgList(params).then(res => {
        this.designImgList = res.data
        this.searchCondition2.page = res.data.current_page
        this.searchCondition2.total = res.data.total
        console.log('designImgList====111', this.designImgList)
      })
    },
    dtcEnableFn(value) {
      this.getPrintInfo(value)
    },

    getPrintInfo(item, n) {
      if (!n) {
        this.setCopyProductId('')
        this.isShowDetail = true
        console.log('###')
        console.log(item)
        this.imgId = item.id
      } else {
        this.isShowDetail = false
        console.log('!!!!')
        console.log(item)
      }
      console.log('printImgInfo====111', this.printImgInfo)
      // 清楚分类选择
      // this.categorySelect = []
      this.GetSingleImgInfo(n ? item : item.id)
      this.search2()
    },
    search() {
      this.getImgListMethod({ ...this.searchCondition, page: 1 })
    },
    search2() {
      this.getDesignImgListMethod({ ...this.searchCondition2, page: 1 })
    },
    // startImgMove(value) {
    //   // console.log(value)
    // },
    imgMoving(e) {
      this.canAddImg = e.clientX > 460 && e.clientX <= 1340 && e.clientY > 270 && e.clientY <= 970
    },
    endImgMove(value) {
      this.canAddImg && this.addImgToFabric(value)
    }
  }
}
</script>

<style lang="less" scoped>
.fuzzy {
  filter: blur(8px);
}
.leftWrap {
  position: relative;
  display: flex;
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  .switchFix {
    position: fixed;
    top: 55px;
    left: 80px;
    bottom: 0;
    right: 0;
    background: rgba(102, 102, 102, 0.3);
    z-index: 88;
  }
  .menuWrap {
    width: 80px;
    border-right: 1px solid #eee;
    text-align: center;
    .menuItem {
      height: 56px;
      padding-top: 8px;
      margin-top: 20px;
      font-size: 12px;
      color: #666;
      border-left: 4px solid #fff;
      cursor: pointer;
      .imgBgBox {
        margin: 0 0 4px 0;
        height: 24px;
      }
      p {
        margin: 0;
      }
      .icon_0 {
        background: url('../../../assets/design/left_1.png') center center no-repeat;
      }
      .icon_1 {
        background: url('../../../assets/design/left_2.png') center center no-repeat;
      }
      .icon_2 {
        background: url('../../../assets/design/left_3.png') center center no-repeat;
      }
      .icon_3 {
        background: url('../../../assets/design/left_4.png') center center no-repeat;
      }
      .icon_4 {
        background: url('../../../assets/design/left_5.png') center center no-repeat;
      }
      &.on {
        border-left: 4px solid #3699ff;
        color: #3699ff;
        background: rgba(54, 153, 255, 0.1);
        .icon_0 {
          background: url('../../../assets/design/left_1_hr.png') center center no-repeat;
        }
        .icon_1 {
          background: url('../../../assets/design/left_2_hr.png') center center no-repeat;
        }
        .icon_2 {
          background: url('../../../assets/design/left_3_hr.png') center center no-repeat;
        }
        .icon_3 {
          background: url('../../../assets/design/left_4_hr.png') center center no-repeat;
        }
        // .icon_4 {
        //   // background: url('../../../assets/design/new_12.png') center center no-repeat;
        // }
      }
    }
  }
  .sidebarWrap {
    position: relative;
    width: 320px;
    z-index: 99;

    .sidebarBox {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 20px 0 0 0;
      &.w640 {
        position: absolute;
        width: 640px;
        z-index: 99;
        background: #fff;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      }
      .switch {
        position: absolute;
        display: flex;
        align-items: center;
        top: calc(50% - 50px);
        right: -18px;
        z-index: 99;
        cursor: pointer;
        width: 18px;
        height: 50px;
        background: #fff;
        border-radius: 0 10px 10px 0;
        justify-content: center;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        .icon {
          margin: 0 auto;
          color: #707070;
        }
      }
      .sidebarHide {
        position: relative;
        flex: 1;
        display: flex;
        overflow-y: hidden;
        background: #fff;
        padding-bottom: 50px;
        .hideBox {
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          .sidebarHead {
            padding: 0 20px 2px 20px;
            .stWrap {
              border-radius: 4px;
              margin-bottom: 20px;
            }
            .stItem {
              float: left;
              width: 50%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #f6f7f9;
              border-radius: 4px;
              cursor: pointer;
              &.on {
                background: #fff;
                box-shadow: 0px 1px 4px rgba(51, 51, 51, 0.2);
              }
            }
            .upImgWrap {
              height: 32px;
              margin-bottom: 10px;
              line-height: 32px;
              background: #f6f7f9;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
            }
            .tabList {
              position: relative;
              width: 86px;
              padding: 0 6px;
              height: 32px;
              border-radius: 4px;
              line-height: 32px;
              font-size: 14px;
              color: #fff;
              text-align: center;
              cursor: pointer;
              span {
                display: block;
                width: 100%;
                overflow: hidden;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              &.bg1 {
                background: #f8704b;
              }
              &.bg2 {
                background: #3699ff;
              }
              &.bg3 {
                background: #00c4cc;
              }
              .tabPop {
                display: none;
                position: absolute;
                left: 0;
                top: 30px;
                width: 100%;
                padding-top: 8px;
                z-index: 9;
                .tabPopBox {
                  padding: 4px 0;
                  max-height: 220px;
                  overflow-y: auto;
                  background: #ffffff;
                  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
                  border-radius: 4px;
                  &::-webkit-scrollbar {
                    /*滚动条整体样式*/
                    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
                    height: 1px;
                  }
                  &::-webkit-scrollbar-thumb {
                    /*滚动条里面小方块*/
                    border-radius: 10px;
                    // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
                    background: rgba(6, 6, 13, 0.2);
                  }
                  &::-webkit-scrollbar-track {
                    /*滚动条里面轨道*/
                    border-radius: 10px;
                    background: white;
                  }
                  .popList {
                    height: 30px;
                    padding: 0 12px;
                    font-size: 14px;
                    color: #666;
                    line-height: 30px;
                    text-align: left;
                    span {
                      display: block;
                      width: 100%;
                      overflow: hidden;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    &:hover {
                      background: #ddecf9;
                    }
                  }
                }
              }
              &:hover {
                .tabPop {
                  display: block;
                }
              }
            }
            .addTextBtn {
              height: 32px;
              margin-bottom: 10px;
              font-size: 16px;
              line-height: 32px;
              background: #f6f7f9;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
            }
            .fontInpue {
              background: #f6f7f9;
              border-radius: 4px;
            }
            .fontSelect {
              margin-top: 12px;
              .fontWrap {
                float: left;
                width: 170px;
                &.maxWidth {
                  width: 490px;
                }
              }
              .fontSizeWrap {
                position: relative;
                float: right;
                border-radius: 4px;
                width: 70px;
                height: 32px;
                line-height: 32px;
                color: #666;
                text-align: left;
                padding-left: 10px;
                background: #f6f7f9;
                .sizeSp {
                  display: block;
                }
                .caretBox {
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  div {
                    margin: -4px 0;
                    line-height: 1;
                    font-size: 12px;
                    color: #666;
                  }
                }
              }
            }
            .fontColorWrap {
              margin-top: 10px;
              border: 1px solid #fafafa;
              border-radius: 4px;
              padding: 10px;
              background: #fff;
              .colorWrap {
                position: relative;
              }
              .fontColorTit {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                color: #666;
                align-items: center;
                .showColorBtn {
                  cursor: pointer;
                }
                .colorBtn {
                  display: inline-block;
                  width: 30px;
                  height: 30px;
                  border-radius: 4px;
                  border: 1px solid #ccc;
                  cursor: pointer;
                  &.black {
                    margin-right: 10px;
                    background: #000;
                  }
                  &.white {
                    background: #fff;
                  }
                }
              }
              .colorBlock {
                margin-top: 10px;
                height: 30px;
                background: #000000;
                border-radius: 4px;
                cursor: pointer;
              }
            }
            .notCanvasColor {
              font-size: 16px;
              color: #999;
              padding: 50px 0;
              text-align: center;
            }
            .myBut {
              width: 100%;
              display: flex;
              margin-top: 10px;
              justify-content: space-between;
              align-items: center;
            }
            .bgColorWrap {
              display: inline-block;
              width: 92px;
              height: 24px;
              padding: 0 10px;
              line-height: 24px;
              border: 1px solid #eeeeee;
              background: #fff;
              border-radius: 4px;
              text-align: center;
              &.maxWidth {
                width: 412px;
              }
            }
            .colorSelectSp {
              display: inline-block;
              width: 24px;
              height: 24px;
              border-radius: 4px;
              cursor: pointer;
            }
            .bgColorReset {
              display: inline-block;
              width: 50px;
              height: 24px;
              line-height: 24px;
              color: #fff;
              background: #3699ff;
              border-radius: 4px;
              text-align: center;
            }
            .setColorBtn {
              height: 32px;
              margin: 10px 0;
              color: #fff;
              line-height: 32px;
              background: #3699ff;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
            }
            .colorSelectBlock {
              margin-top: 10px;
              .colorSelectBox {
                margin: 0 -5px;
              }
              .colorSelect {
                float: left;
                width: 38px;
                height: 38px;
                margin: 5px;
                border-radius: 4px;
                cursor: pointer;
              }
            }
          }
          .sidebarMain {
            flex: 1;
            overflow: auto;
            display: flex;
            flex-direction: column;
            .sidebarMainAuto,
            .detailWrap {
              height: 100%;
              overflow-y: auto;
              padding-bottom: 20px;
              &::-webkit-scrollbar {
                /*滚动条整体样式*/
                width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
                height: 1px;
              }
              &::-webkit-scrollbar-thumb {
                /*滚动条里面小方块*/
                border-radius: 10px;
                // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
                background: rgba(6, 6, 13, 0.2);
              }
              &::-webkit-scrollbar-track {
                /*滚动条里面轨道*/
                border-radius: 10px;
                background: white;
              }
              .imgItem {
                position: relative;
                overflow: hidden;
                float: left;
                width: 130px;
                height: 130px;
                margin-left: 20px;
                margin-top: 20px;
                border-radius: 4px;
                // border: 1px solid #ddd;
                background-color: #f6f7f9;
                background-repeat: no-repeat;
                background-position: 50%;
                background-size: cover;
                background-blend-mode: multiply;
                cursor: pointer;
                &.noBor {
                  border: none;
                }
                .fast {
                  position: absolute;
                  left: 10px;
                  top: 10px;
                  width: 38px;
                  height: 18px;
                  border-radius: 4px;
                  color: #fff;
                  font-size: 13px;
                  font-weight: 700;
                  line-height: 18px;
                  background-color: #39c5eb;
                  text-align: center;
                  z-index: 1;
                }
                .promotionWrap {
                  position: absolute;
                  top: 0;
                  left: 4px;
                  z-index: 1;
                }
                .tort {
                  position: absolute;
                  top: 0;
                  left: 0;
                  span {
                    position: absolute;
                    top: 2px;
                    left: -2px;
                    transform: rotate(-45deg) scale(0.8);
                    font-size: 12px;
                    color: white;
                    font-weight: bold;
                  }
                  img {
                    height: 45px;
                  }
                }
              }
            }
            .detailWrap {
              padding: 0 20px;
              .nameTit {
                margin-bottom: 12px;
                font-size: 14px;
                color: #3699ff;
                cursor: pointer;
              }
              .imgBox {
                float: left;
                overflow: hidden;
                width: 120px;
                height: 120px;
                border: 1px solid #eee;
                border-radius: 4px;
                img {
                  width: 120px;
                  height: 120px;
                }
              }
              .cpInfo {
                overflow: hidden;
                padding-left: 10px;
                h6 {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-size: 16px;
                  color: #666;
                  margin-bottom: 6px;
                }
                p {
                  margin: 0;
                }
                .code {
                  font-size: 12px;
                  color: #999;
                }
                .money {
                  margin: 4px 0 0 0;
                  font-size: 16px;
                  color: #ff0000;
                  line-height: 1;
                  font-weight: bold;
                  img {
                    height: 20px;
                    margin-left: 2px;
                    vertical-align: -4px;
                  }
                  .yellow {
                    font-size: 10px;
                    color: #f59a23;
                  }
                  .old_pricce {
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    text-decoration: line-through;
                    margin-left: 5px;
                  }
                  .promotion_percent {
                    background: #ffffff;
                    border: 1px solid #ffa200;
                    border-radius: 2px;
                    text-align: center;
                    padding: 0px 4px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #ffa200;
                    margin: 8px 0;
                  }
                }
                .viewBtn {
                  cursor: pointer;
                  color: #3699ff;
                }
              }
              .listTitle {
                margin: 20px 0 10px 0;
              }
              .listBox {
                margin: 0 -6px;
                .sizeSp {
                  float: left;
                  margin: 6px;
                  line-height: 32px;
                  padding: 0 12px;
                  color: #666;
                  border: 1px solid #eee;
                  border-radius: 4px;
                  cursor: pointer;
                  &.on {
                    border: 1px solid #3699ff;
                    color: #3699ff;
                  }
                  &:hover {
                    border: 1px solid #3699ff;
                    color: #3699ff;
                  }
                }
                .colorSp {
                  margin: 6px;
                  float: left;
                  width: 32px;
                  height: 32px;
                  border: 2px solid #eee;
                  border-radius: 4px;
                  cursor: pointer;
                  &.on {
                    border: 2px solid #3699ff;
                  }
                  &:hover {
                    border: 2px solid #3699ff;
                  }
                }
              }
            }
            .imgListWrap {
              .ctSpBox {
                padding: 20px 20px 0 20px;
                color: #3699ff;
                span {
                  cursor: pointer;
                }
              }
              .imgListTop {
                padding: 10px 20px 0 20px;
                margin: 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #666;
                .pointer {
                  cursor: pointer;
                }
              }
            }
          }
          .stBtn {
            position: relative;
            width: 32px;
            height: 32px;
            background: #ffffff;
            border: 1px solid #ddd;
            border-radius: 4px;
            cursor: pointer;
            &.fl {
              float: left;
            }
            &.fr {
              float: right;
            }
            .hSpBox {
              height: 100%;
              line-height: 30px;
              font-size: 18px;
              color: #666;
              text-align: center;
              // padding-top: 8px;
            }
            &.on,
            &:hover {
              border: 1px solid #3699ff;
              .menuBtn {
                color: #3699ff;
              }
            }
            &.customerBtnBox {
              position: relative;
              .hSpBox {
                background: url('../../../assets/design/left_6.png') center center no-repeat;
              }
              &.on,
              &:hover {
                border: 1px solid #3699ff;
                .hSpBox {
                  background: url('../../../assets/design/left_6_hr.png') center center no-repeat;
                }
              }
            }
          }
          .inputCss {
            width: 228px;
            &.maxWidth {
              width: 548px;
            }
            cursor: pointer;
            font-size: 16px;
            &.fl {
              float: left;
            }
            &.fr {
              float: right;
            }
          }
        }
        .paginationBox {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 50px;
          padding-top: 15px;
          background: #fff;
          text-align: center;
          box-shadow: 2px 0px 6px rgba(0, 0, 0, 0.1);
          z-index: 9;
        }
      }
      .sidebarAuto {
        position: relative;
        height: 240px;
        box-shadow: 2px 0px 6px rgba(0, 0, 0, 0.1);
        z-index: 100;
        .layersTitle {
          position: absolute;
          height: 40px;
          width: 100%;
          padding: 0 20px;
          border-bottom: 1px solid #ddd;
          font-size: 14px;
          color: #3699ff;
          line-height: 40px;
          background: #fff;
          z-index: 6;
          .closeBtn {
            position: absolute;
            top: 0;
            right: 20px;
            font-size: 20px;
            line-height: 40px;
            color: #666;
            cursor: pointer;
            z-index: 2;
            &:hover {
              color: #3699ff;
            }
          }
        }
        .tcHidden {
          height: 100%;
          overflow-y: auto;
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
            background: rgba(6, 6, 13, 0.2);
          }
          &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 10px;
            background: white;
          }
        }
        .layersCt {
          padding: 40px 0 16px 0;
        }
        .layerItem {
          height: 40px;
          padding: 5px 16px;
          width: 100%;
          // border-radius: 5px;
          margin-top: 5px;
          overflow: hidden;
          display: flex;
          // border: 1px solid #ddd;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s;

          &:hover {
            // box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
            background: #eaf5ff;
          }
          .controlLayer {
            width: 55px;
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
}
.controlTab {
  // display: flex;
  // justify-content: space-between;
  .ant-btn {
    background: #4c9be0;
    color: white;
  }
}
.imgList {
  padding-bottom: 10px;
  position: relative;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);

  .imgItemWrap {
    padding: 0 16px;
    padding-top: 20px;
    padding-bottom: 15px;
    margin-top: 20px;
    overflow: auto;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
      background: rgba(6, 6, 13, 0.2);
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: white;
    }
    .imgUpload {
      border-radius: 5px;
      height: 90px;
      width: 90px;
      line-height: 90px;
      text-align: center;
      float: left;
      transition: all 0.3s;
      margin-top: 10px;
      border: 1px dashed #cccccc;
      &:hover {
        cursor: pointer;
        border: 1px dashed #4b9bdf;
        i {
          color: #4b9bdf;
          transition: all 0.3s;
        }
      }
    }
    .imgItemActive {
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
    }
    .imgItem {
      position: relative;
      border-radius: 5px;
      height: 90px;
      width: 90px;
      float: left;
      margin-top: 10px;
      transition: all 0.3s;
      background: #f5f5f5;
      .fast {
        position: absolute;
        left: 10px;
        top: 10px;
        width: 38px;
        height: 18px;
        border-radius: 4px;
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        line-height: 18px;
        background-color: #39c5eb;
        text-align: center;
        z-index: 1;
      }
      .tort {
        position: absolute;
        top: 0;
        left: 0;
        span {
          position: absolute;
          top: 2px;
          left: -2px;
          transform: rotate(-45deg) scale(0.8);
          font-size: 12px;
          color: white;
          font-weight: bold;
        }
        img {
          height: 45px;
        }
      }
      .promotionWrap {
        position: absolute;
        top: 0;
        left: 4px;
        z-index: 1;
      }
      &:hover {
        cursor: pointer;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
      }
      &:nth-child(3n + 2) {
        margin: 0 15px;
        margin-top: 10px;
      }
    }
  }
}
.productModal {
  .cpBlock {
    .cpImgBox {
      overflow: hidden;
      float: left;
      width: 80px;
      height: 80px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      img {
        width: 80px;
        height: 80px;
      }
    }
    .cpInfoBox {
      overflow: hidden;
      padding-left: 10px;
      .name {
        font-size: 16px;
        color: #333;
        margin: 0;
      }
      .code {
        margin: 6px 0 6px 0;
        font-size: 12px;
        color: #999;
      }
      .money {
        font-size: 16px;
        color: #ff0000;
        img {
          height: 20px;
          margin-left: 4px;
          vertical-align: top;
        }
        .old_pricce {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          text-decoration: line-through;
          margin-left: 5px;
        }
        .promotion_percent {
          color: #ffffff;
          text-align: center;
          background: #d7d7d7;
          padding: 0px 4px;
          font-size: 10px;
          margin-left: 5px;
        }
      }
    }
  }
  .tabBlock {
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    .tabItem {
      display: inline-block;
      height: 32px;
      padding: 0 12px;
      line-height: 32px;
      border-radius: 4px;
      margin-right: 20px;
      border: 1px solid #d9d9d9;
      color: #666;
      background: #fff;
      cursor: pointer;
      &:hover,
      &.on {
        border: 1px solid #3699ff;
        color: #fff;
        background: #3699ff;
      }
    }
  }
  .productBody {
    margin-top: 20px;
    max-height: 420px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
      background: rgba(6, 6, 13, 0.2);
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: white;
    }
  }
  .row-div {
    margin-bottom: 20px;
    span {
      color: #333;
      line-height: 32px;
    }
  }
  .rowTitle {
    font-weight: bold;
    font-size: 16px;
    color: #333;
  }
  .tips-div {
    margin-top: 12px;
    color: #333;
    line-height: 24px;
  }
  .size-head {
    display: table;
    width: 100%;
  }
  .head-item {
    display: table-cell;
    width: 120px;
    font-size: 14px;
    color: #666;
    padding: 12px;
    line-height: 24px;
    text-align: center;
    vertical-align: middle;
    background: #e9f5ff;
  }
  .size-body {
    display: table;
    width: 100%;
    border-left: 1px solid #eee;
    border-bottom: 1px solid #eee;
    // margin: 4px 0 0 0;
  }
  .body-item {
    display: table-cell;
    width: 160px;
    font-size: 14px;
    padding: 8px;
    color: #666;
    line-height: 20px;
    text-align: center;
    vertical-align: middle;
    background: #fff;
    border-right: 1px solid #eee;
  }
}
</style>
